import { css } from 'lit';
export const dropDownDialogStyles = css `
    :host {
        position: relative;
        display: block;
        color: var(--ep-text-color);
        font-size: var(--ep-text-font-size);
        font-family: var(--ep-text-font-family);
        min-width: var(--ep-dropdown-dialog-min-width, 180px);
    }

    :host([disabled]) .header,
    :host([disabled]) ep-label:not(.value) {
        cursor: not-allowed;
        background-color: var(--ep-color-gray-3);
    }

    :host([active]) .header {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    :host([active]) .header::after {
        transform: translateY(-50%) rotate(180deg);
    }
    :host([active]) .body {
        max-height: 200px;
        border-bottom: var(--ep-dropdown-dialog-border, 2px solid var(--ep-dropdown-dialog-border-color, var(--ep-color-tertiary)));
    }

    :host([active]) .body,
    :host([active]) .header,
    :host(.highlighted) .body,
    :host(.highlighted) .header {
        border-color: var(--ep-color-primary);
    }

    :host(.highlighted) .header ep-label,
    :host([active]) .header ep-label {
        --ep-label-text-color: var(--ep-color-primary);
    }

    :host(.highlighted) .header ep-label {
        --ep-label-text-font-weight: bold;
    }

    :host(:focus) .header,
    :host(:focus-visible) .header,
    :host(:focus) .body,
    :host(:focus-visible) .body,
    :host([active]) .body,
    :host([active]) .header {
        border-color: var(--ep-color-primary);
    }

    :host(:focus-visible) {
        outline: none;
    }

    :host(.disabled:focus) .header,
    :host(.disabled:focus-visible) .header {
        border-color: var(--ep-dropdown-border-color, var(--ep-color-tertiary));
        box-shadow: none;
    }

    :host([active]) .header ep-label {
        --ep-label-text-color: var(--ep-color-primary);
    }

    .header {
        cursor: pointer;
        position: relative;
        box-sizing: border-box;
        width: var(--ep-dropdown-width, 100%);
        border: var(--ep-dropdown-border, 2px solid var(--ep-dropdown-border-color, var(--ep-color-tertiary)));
        min-height: var(--ep-dropdown-header-height, 36px);
        box-shadow: var(--ep-color-tertiary);
        border-radius: var(--ep-dropdown-header-border-radius, 3px);
        line-height: 22px;
    }

    .header::after {
        content: '';
        width: 0.8em;
        height: 0.5em;
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        transition: transform 400ms ease-in-out;
        background-color: var(--ep-color-tertiary);
        clip-path: polygon(100% 0%, 0% 0%, 50% 100%);
    }

    ep-label {
        --ep-label-text-font-size: var(--ep-dropdown-dialog-label-font-size, 14px);
        display: inline-block;
        white-space: nowrap;
        pointer-events: none;
        background-color: var(--ep-color-white);
        padding: var(--ep-dropdown-dialog-label-top-space, 9px) 36px 0 10px;
        transition: 0.2s ease all;
        -moz-transition: 0.2s ease all;
        -webkit-transition: 0.2s ease all;
        line-height: 1;
    }

    .body {
        position: absolute;
        box-sizing: border-box;
        width: var(--ep-dropdown-dialog-width, 100%);
        margin-top: -2px;
        border-bottom-left-radius: var(--ep-dropdown-header-border-radius, 3px);
        border-bottom-right-radius: var(--ep-dropdown-header-border-radius, 3px);
        border: var(--ep-dropdown-dialog-border, 2px solid var(--ep-dropdown-dialog-border-color, var(--ep-color-tertiary)));
        border-bottom: 0;
        border-top: none;
        overflow: hidden auto;
        z-index: 99;
        background: var(--ep-color-white);
        max-height: 0;
        transition: max-height 200ms ease-out;
    }

    .content {
        box-sizing: border-box;
        padding: var(--ep-dropdown-dialog-body-inner-space, 10px);
    }

    slot[name='header']::slotted(*),
    .header div {
        padding: var(--ep-dropdown-padding, 5px 10px);
    }

    slot[name='body']::slotted(*) {
        display: block;
        cursor: pointer;
        border-bottom: 1px solid var(--ep-color-gray-3);
        padding: var(--ep-dropdown-padding, 5px 10px);
    }

    slot[name='body']::slotted(:last-child) {
        border-bottom: none;
    }

    slot[name='body']::slotted(.focused),
    slot[name='body']::slotted(:hover) {
        background-color: var(--ep-dropdown-item-hover-bg-color, var(--ep-color-gray-1));
        color: var(--ep-dropdown-item-hover-color, var(--ep-color-black));
        font-weight: var(--ep-dropdown-item-hover-font-weight, bold);
    }
`;
//# sourceMappingURL=syles.js.map